import React from "react";

import useGrpcQuery from "../../../lib/hooks/useGrpcQuery";
import { useAnalytics } from "../../../api/grpc/analytics/useAnalytics";
import { useTimeZoneContext } from "../../../lib/context/TimeZone/TimeZoneContext";
import { useMediaQuery } from "../../../lib/hooks/useMediaQuery";

import { LoadingBox } from "../../shared/LoadingBox/LoadingBox";
import { ChartBox } from "../../shared/ChartBox/ChartBox";

import { tooltips } from "../../../lib/utils/tooltips";
import { InformationBox } from "../../shared/InformationBox/InformationBox";
import { HandleRequestState } from "../../shared/HandleRequestState/HandleRequestState";

import {
  CustomerRequest,
  InsightsResponse,
} from "../../../api/grpc/analytics/analytics";

export const InsightsBox = () => {
  // const { getRoomsTimeRangeEvents } = useInsightsRequests();
  const { getInsights } = useAnalytics();
  const { timeZone } = useTimeZoneContext();
  const compactChart = useMediaQuery("(max-width: 767px)");

  const { loading, error, data } = useGrpcQuery<
    Omit<CustomerRequest, "customerID">,
    InsightsResponse
  >({
    method: getInsights,
    variables: {
      timeZone,
    },
  });

  return (
    <div className="ChartBox HomeInsights">
      <HandleRequestState
        state={loading}
        placeholder={
          <div
            className="HomeInsights__loading"
            aria-label="Loading Insights"
            aria-busy="true"
          >
            <LoadingBox className="LoadingBox--chart" />
          </div>
        }
      >
        <HandleRequestState
          state={!!error}
          placeholder={
            <div className="default-box HomeInsights__card">
              <h3 className="d-flex align-items-center">
                Insights
                <InformationBox
                  leftDiff
                  message={tooltips.dashboard.insights}
                />
              </h3>

              <p className="HomeInsights__error" role="alert">
                {error?.message || "Insights failed to load, please try again!"}
              </p>
            </div>
          }
        >
          <div className="default-box HomeInsights__card">
            <h3 className="d-flex align-items-center">
              Insights
              <InformationBox leftDiff message={tooltips.dashboard.insights} />
            </h3>
            <div className="HomeInsights__chartFrame">
              <div className="HomeInsights__plot">
                <ChartBox data={data} compact={compactChart} />
              </div>
            </div>
          </div>
        </HandleRequestState>
      </HandleRequestState>
    </div>
  );
};
